import { METRIC_DISTRIBUTION } from "@/constants";
import { summaryRow } from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";

export default {
  family: [FAMILY.OTHER],
  recommendedFamily: [FAMILY.OTHER],
  name: "",
  title: "Plan Summary",
  defaultHeight: 8,
  widgetSettings: {
    widget: "DataTable",
  },
  planOnly: true,
  settings: {},
  planSettings: {
    distribution: { default: METRIC_DISTRIBUTION },
    columns: {
      default: [
        {
          title: "Plan",
          value: "plan",
        },
        {
          title: "Start Date",
          value: "start_date",
        },
        {
          title: "End Date",
          value: "end_date",
        },
        {
          title: "% of Budget",
          value: "channel_percentage",
        },
        {
          title: "Budget",
          value: "budget",
        },
      ],
    },
    summaryRow: { ...summaryRow, gridPosition: [0, 0] },
  },
};
